import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { FormFieldDefinition } from '../../models/dynamic-form.interfaces';

@Component({
  selector: 'mojo-validation-messages',
  templateUrl: './validation-messages.component.html',
})
export class ValidationMessagesComponent implements OnInit, OnChanges, OnDestroy {

  @Input() definition: FormFieldDefinition;
  @Input() formField: UntypedFormControl;

  isAlive = true;
  loading$: Observable<boolean>;

  constructor() {
  }

  ngOnInit() {

  }

  ngOnChanges() {
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

}
